import React from 'react';
import Projects from './Projects';


const Portfolio = () => {



  return (
    <section id='portfolio' className='section bg-primary min-h-[1400px]'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center text-center'>
          <h2 className='section-title before:content-portfolio relative before:absolute before:opacity-40 before:-top-[2rem] before:-left-3/4 before:hidden before:lg:block'>
            My latest work
          </h2>
          <p className='subtitle'>
          Each day, new projects and opportunities will be added to the site. Some of these projects may be short-term while others are long-term, meaning they will last for a few days to many months.
          </p>
        </div>
        <Projects />
      </div>
    </section>
  );
};

export default Portfolio;
